import { render, staticRenderFns } from "./ReminderPlans.vue?vue&type=template&id=16b9d54a&"
import script from "./ReminderPlans.vue?vue&type=script&lang=js&"
export * from "./ReminderPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports